import { HttpErrorResponse } from '@angular/common/http';
import {
  GeneralNotifications
} from '../../../shared/models/notification/notification.model';

/**
 * Error state interface
 */
export interface NotificationErrorState {
    name: string;
    error: HttpErrorResponse;
}

/**
 * Notification state interface
 */
export interface NotificationState {
    /**
     * Notification Stats
     */
    total?: GeneralNotifications | null;
    /**
     * Notification api errors that have occurred during notification session.
     */
    errors?: string[];
}

/**
 * Initial notification state
 */
export const initialNotificationState: NotificationState = {
    total: null,
    errors: [],
};
